/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=4b62fe16&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=4b62fe16&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b62fe16"]])

export default __exports__